<template>
	<nav>
    <VTabsV2Grouped
      :tabs="tabs"
      :active-id="activeTabId"
      base-url="/flow/offers"
    />
    <VReloadButton title="Обновить список предложений" @renew-data="onForceReload"/>
  </nav>

	<OffersRegistryExpanded
		ref="registry"
		:params="registryParams"
	/>
</template>

<script lang="ts">
import Core              from "@/core/Core";
import OffersService     from "@/domains/Offers/OffersService";

import OffersRegistry    from "@/domains/Offers/components/OffersRegistry/OffersRegistry.vue";
import VTabsV2Grouped    from "@/lib/components/VTabsV2Grouped/VTabsV2Grouped.vue";
import OffersRegistryExpanded
  from "@/domains/Offers/components/OffersRegistryExpanded/OffersRegistryExpanded.vue";
import type TabElement from "@/lib/components/VTabsV2/TabElement";


export default defineComponent({
	name: 'OffersFlow',

	components: {
    OffersRegistryExpanded,
		VTabsV2Grouped,
	  OffersRegistry
	},

	setup() {
		return {
			OffersService,
		};
	},

	computed: {
		tabs(): TabElement[] {
			const role = Core.currentPartner.isSeller ? 'seller' : 'buyer';
			return OffersService.getOffersFlowTabs(role);
		},

		activeTabId(): string {
			// Получаем сегмент из URL: /flow/offers/all -> 'all'
			const pathSegments = this.$route.path.split('/');
			// Ищем последний сегмент после 'offers'
			const offersIndex = pathSegments.indexOf('offers');
			const tabSegment = pathSegments[offersIndex + 1];

			// Проверяем, существует ли такой таб
			const validTab = this.tabs.find(t => t.id === tabSegment);
			return validTab?.id ?? OffersService.DEFAULT_TAB_ID;
		},

		registryParams(): Parameters<typeof OffersService.getListPaginated>[0] {
			return {
				... this.getRequestParamsByTab(this.activeTabId),
			};
		},
	},

	methods: {
		onForceReload() {
			(this.$refs.registry as any)?.refresh();
		},

    /**
     * Параметры запроса для активной вкладки.
     */
    getRequestParamsByTab(activeTabId: string): Parameters<typeof OffersService.getListPaginated>[0] {
      const result: Record<string, unknown> = {};

      switch (activeTabId) {
        case 'bookmarked':
          result.isBookmarked = true;
          break;
        case 'my-active':
          result.onlyMine = true;
          result.isPublished = true;
          break;
        case 'my-inactive':
          result.onlyMine = true;
          result.isPublished = false;
          break;
        case 'isNotSamples':
          result.isSamples = false;
          break;
        case 'isSamples':
          result.isSamples = true;
          break;
        case 'all':
        default:
          break;
      }

      return result;
    },
	},
});
</script>

